/* import __COLOCATED_TEMPLATE__ from './grid-area.hbs'; */
import Component from '@ember/component';
import { service } from '@ember/service';
import { computed, action } from '@ember/object';

////////////////////////////////////////////////////////////////////////////////////
// grid-area - Component that displays table of recommended parts & links to PST  //
////////////////////////////////////////////////////////////////////////////////////

export default class GridArea extends Component {
  tagName = '';
  grid = null;
  @service('aditools-analytics') analytics;
  isExpandedTableOpen = null;

  ////////////////////////////////////////////////////////////////////////////////
  // Computed Values                                                            //
  ////////////////////////////////////////////////////////////////////////////////

  @computed('isDiffPGIASchematic') get showRecommendedInAmpsFilter() {
    return !this.isDiffPGIASchematic;
  }

  @computed('adiBaseURL', 'recommendedParts', 'urlQuestion') get gridDisplayData() {
    return this.recommendedParts.map((part, index) => {
      return {
        id: part.id,
        description: part.description,
        url: `${this.adiBaseURL}/${part.url}${this.urlQuestion}`,
        rowColor: index % 2 === 0 ? 'even' : 'odd',
      };
    });
  }

  ////////////////////////////////////////////////////////////////////////////////
  // User Functions                                                             //
  ////////////////////////////////////////////////////////////////////////////////

  sendAnalytics(act, partId) {
    switch (act) {
      case 'recommendedList':
        this.analytics.setWebEvent(this.toolConfigData.toolName, 'openParametricTable', this.recommendedInAmpsUrl);
        break;
      case 'recommended':
        this.analytics.setWebEvent(this.toolConfigData.toolName, 'openParametricTable', '');
        break;
      case 'part':
        if (partId) this.analytics.setWebEvent(this.toolConfigData.toolName, 'productView', partId);
        break;
    }
  }

  ////////////////////////////////////////////////////////////////////////////////
  // Component Actions                                                          //
  ////////////////////////////////////////////////////////////////////////////////

  @action insertingGrid() {
    var self = this;
    document.querySelector('#recommendedPartsGrid').addEventListener('click', function (evt) {
      let linkNode = evt.target.parentNode;
      if (linkNode && linkNode.className === 'recommended-part-item') {
        var act = linkNode.getAttribute('data-action') || '';
        var partId = linkNode.getAttribute('data-partid');
        self.sendAnalytics(act, partId);
      }
    });
  }

  @action linkClicked(evt) {
    var act = evt.target.getAttribute('data-action') || '';
    this.sendAnalytics(act, '');
  }

  @action openExpandedTable() {
    this.set('isExpandedTableOpen', true);
  }

  @action closeExpandedTable() {
    this.set('isExpandedTableOpen', false);
  }
}
